import { useCurrencyAmountFormatter } from '@routable/shared';
import React from 'react';
import { ExternalBlock, ExternalBlockItem } from 'modules/external/ExternalBlocksSection';
import {} from './ExternalReceiptPaymentHeader.types';
import './ExternalReceiptPaymentHeader.scss';
const ExternalReceiptPaymentHeader = ({ item }) => {
    const { formatCurrencyAmount } = useCurrencyAmountFormatter();
    const amountLabel = item.isInternational ? 'Estimated amount' : 'Amount';
    const headerTitle = `${amountLabel} you'll receive`;
    const hasExchangeRate = item.isInternational && item.currencyCodeCompany !== item.currencyCodeReceiver;
    return (React.createElement(ExternalBlock, { className: "external-receipt-payment-header" },
        React.createElement(ExternalBlockItem, null,
            React.createElement("span", { className: "text-sm text-grey-60" }, headerTitle),
            React.createElement("span", { className: "external-receipt-payment-header__price text-black" }, formatCurrencyAmount({ amount: item.amountPartner, currency: item.currencyCodeReceiver })),
            hasExchangeRate && (React.createElement("div", { className: "text-xs text-black border-t border-grey-10 bg-grey-5 p-5 mt-5 m-[-16px]" },
                React.createElement("div", { className: "flex justify-between mb-2 font-medium" },
                    React.createElement("span", null,
                        "Payment amount (",
                        item.currencyCodeCompany,
                        ")"),
                    React.createElement("span", null, formatCurrencyAmount({ amount: item.amountCompany, currency: item.currencyCodeCompany }))),
                React.createElement("div", { className: "flex justify-between font-medium" },
                    React.createElement("span", null, "Conversion rate"),
                    React.createElement("span", null,
                        "1 USD =",
                        ' ',
                        formatCurrencyAmount({ amount: item.exchangeRate, currency: item.currencyCodeReceiver, precision: 4 }))))))));
};
export default ExternalReceiptPaymentHeader;
